import ChevronRight from "@mui/icons-material/ChevronRight";
import { Divider, Skeleton, Stack, Typography } from "@mui/material";
import { ChevronDown } from "../../../../styles/icons/chevron-down";
import { AnalyticsExportButton } from "./export-button";

import type { UUID } from "../../../../utils/uuid";
import type { FC } from "react";

export const AnalyticsOverviewHeader: FC<{
  onHeaderClick: () => void;
  expanded: boolean;
  sentTimes: number;
  loading: boolean;
  moment_id: UUID;
}> = ({ onHeaderClick, expanded, sentTimes, loading, moment_id }) => (
  <Stack spacing={1}>
    <Stack
      direction="row"
      onClick={onHeaderClick}
      sx={{ justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}
    >
      <Stack direction="row" spacing={2}>
        {expanded ? (
          <ChevronDown fontSize="small" color="primary" />
        ) : (
          <ChevronRight fontSize="small" color="primary" />
        )}
        <Typography variant="body2">Overview of all Sends</Typography>
      </Stack>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <Typography variant="body2">
          {loading ? (
            <Skeleton data-testid="sent-times-skeleton" width={50} />
          ) : (
            `Sent ${sentTimes} times`
          )}
        </Typography>
        <AnalyticsExportButton disabled={loading} moment_id={moment_id} />
      </Stack>
    </Stack>
    <Divider />
  </Stack>
);
